export type LineRegisterCallbackState = {
  registrationToken: string;
};

export function validateRegisterName(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return "呼び名を入力してください。";
  if (trimmed.length > 100) return "呼び名は100文字以内で入力してください。";
  return null;
}

export function validateInviteCode(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return "招待コードを入力してください。";
  if (trimmed.length > 20) return "招待コードは20文字以内で入力してください。";
  return null;
}
